
export const asUndo = {
    data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.2651 8.5C9.61514 8.5 7.21514 9.49 5.36514 11.1L1.76514 7.5L1.76514 16.5H10.7651L7.14514 12.88C8.53514 11.72 10.3051 11 12.2651 11C15.8051 11 18.8151 13.31 19.8651 16.5L22.2351 15.72C20.8451 11.53 16.9151 8.5 12.2651 8.5Z" fill="#C9CFD4"/>
    </svg>`,
    name: 'undo',
  };
  